var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 3.84375C11.3158 3.84375 3.84375 11.3158 3.84375 20.5C3.84375 29.6842 11.3158 37.1562 20.5 37.1562C29.6842 37.1562 37.1562 29.6842 37.1562 20.5C37.1562 11.3158 29.6842 3.84375 20.5 3.84375ZM26.5307 24.7193C26.6547 24.8371 26.7538 24.9785 26.8223 25.1352C26.8907 25.292 26.9271 25.4608 26.9293 25.6318C26.9315 25.8028 26.8995 25.9725 26.835 26.1309C26.7706 26.2893 26.6751 26.4332 26.5542 26.5542C26.4332 26.6751 26.2893 26.7706 26.1309 26.835C25.9725 26.8995 25.8028 26.9315 25.6318 26.9293C25.4608 26.9271 25.292 26.8907 25.1352 26.8223C24.9785 26.7538 24.8371 26.6547 24.7193 26.5307L20.5 22.3122L16.2807 26.5307C16.0384 26.7608 15.7159 26.8872 15.3818 26.883C15.0477 26.8787 14.7285 26.744 14.4922 26.5078C14.256 26.2715 14.1213 25.9523 14.1171 25.6182C14.1128 25.2841 14.2392 24.9616 14.4693 24.7193L18.6878 20.5L14.4693 16.2807C14.2392 16.0384 14.1128 15.7159 14.1171 15.3818C14.1213 15.0477 14.256 14.7285 14.4922 14.4922C14.7285 14.256 15.0477 14.1213 15.3818 14.1171C15.7159 14.1128 16.0384 14.2392 16.2807 14.4693L20.5 18.6878L24.7193 14.4693C24.9616 14.2392 25.2841 14.1128 25.6182 14.1171C25.9523 14.1213 26.2715 14.256 26.5078 14.4922C26.744 14.7285 26.8787 15.0477 26.883 15.3818C26.8872 15.7159 26.7608 16.0384 26.5307 16.2807L22.3122 20.5L26.5307 24.7193Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.7282cc5187456641d03417c7860f32c8.svg";
export { ForwardRef as ReactComponent };